const markApplications = [
    {
        "uuid": "1",
        "appNo": "2021000001",
        "createdOn": "2021-12-17T18:21:30.000Z",
        "appType": "markReview",
        "customerName": "源天然股份有限公司",
        "markApplicationList": [
            {
                "productName": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "changeDescription": "異動說明...",
            },
            {
                "productName": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "changeDescription": "異動說明...",
            },
            {
                "productName": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "aluminumFoil",
                "spec": "500ml/包",
                "changeDescription": "異動說明...",
            },
        ]
    }
]

export default markApplications;